<template>
  <div class="cbt">
    <ModalSystemError :isCbt="true" v-if="hasError" />
    <h1>全国一斉CBT模擬試験 問題</h1>
    <div class="u-containar-md">
      <div class="head">
        <div class="number">
          問題{{ $store.state.cbtQuestions[currentIndex].qno }}
        </div>
        <div class="time">
          残り時間 {{ formatNumber(leftMinutes) }}:{{
            formatNumber(leftSeconds)
          }}
        </div>
        <div class="question">
          {{ $store.state.cbtQuestions[currentIndex].title }}
        </div>
      </div>
      <div class="img">
        <img
          v-for="(item, index) in $store.state.cbtQuestions[currentIndex].image"
          :key="index"
          :src="item"
          alt=""
        />
      </div>
      <ul class="choices">
        <li
          v-for="(value, key) in $store.state.cbtQuestions[currentIndex]
            .choices"
          :key="key"
        >
          <InputRadioButton
            name="examMasterChoices"
            :id="`answer-${key}`"
            :label="value"
            :value="String(key)"
            :currentValue="selectedIndex"
            @call-input-change="selectIndex"
          />
        </li>
      </ul>
    </div>
    <div class="btnArea">
      <Button
        v-if="currentIndex < $store.state.cbtQuestions.length - 1"
        label="次の問題へ"
        primary
        :handleClick="nextPage"
        :disabled="selectedIndex === null"
      />
      <Button
        v-else
        :label="linkToResultText"
        lightgray
        :handleClick="linkToResult"
        :disabled="selectedIndex === null"
      />
      <Button
        v-if="currentIndex !== 0 && $route.params.category !== 'category5'"
        label="前の問題へ"
        :handleClick="previousPage"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, reactive } from 'vue'
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router'
import store from '@/store/'
import { axiosSetting } from '@/utils/axiosSetting'
import ModalSystemError from '@/components/genenral/ModalSystemError.vue'
import InputRadioButton from '@/components/elements/InputRadioButton.vue'
import Button from '@/components/elements/Button.vue'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')

export default defineComponent({
  name: 'CbtDetail',
  components: {
    Button,
    InputRadioButton,
    ModalSystemError
  },
  props: {
    currentIndex: {
      type: Number,
      default: 0
    }
  },

  beforeRouteEnter: (to: any, from: any, next: any) => {
    const ajax = axiosSetting('app', 'action')

    const previousPage = from.fullPath
    const previousComponent = from.name

    to.matched[0].props.default = {
      currentIndex: Number(to.params.qno) - 1
    }

    next(async (vm: any) => {
      const string = to.params.category
      const params = {
        users_id: vm.$store.state.userInfo.zip,
        year: '2022',
        term: Number(string.substring(string.length - 1)),
        flg: 's'
      }
      const data = await ajax
        .post('/api/v1/cbt_question', params)
        .then((res: any) => {
          return res.data
        })

      vm.$store.commit('setCbtQuestions', data)

      // リロード以外の正規の手段で問題を解き始めたとき
      if (
        previousPage == '/magazines/exam/cbt' ||
        previousComponent == 'examCbtResult' ||
        previousComponent == 'examCbtFail'
      ) {
        vm.timerStart()
        localStorage.setItem('startDate', vm.getCurrentTime())
      } else if (previousPage == '/') {
        // リロードのとき
        // 保存した時間からタイマースタート
        const savedTime = JSON.parse(localStorage.getItem('nowTime') + '')
        vm.leftMinutes = savedTime.minutes
        vm.leftSeconds = savedTime.seconds
        vm.timerStart()
      }
    })
  },

  beforeRouteUpdate: (to: any, from: any, next: any) => {
    const storeData = store.state.cbtQuestions
    if (to.params.qno == 0 || to.params.qno > storeData.length)
      return next('/404')
    to.matched[0].props.default = {
      currentIndex: Number(to.params.qno) - 1
    }
    next()
  },

  beforeRouteLeave: (to: any, from: any, next: any) => {
    localStorage.setItem('myAnswers', '')
    if (to.name !== 'examCbtResult' && to.name !== 'examCbtFail') {
      const answer = window.confirm(
        'ページを離脱してもよろしいですか？解答途中のデータは失われてしまいます。'
      )
      if (!answer) next(false)
    }
    next()
  },

  setup(props) {
    const router = useRouter()
    const route = useRoute()

    const myAnswers: any[] = reactive([])

    const selectedIndex = ref(null)
    const selectIndex = (e: any) => {
      selectedIndex.value = e
    }

    // タイマー系処理まとめ
    // タイマーのon/off管理ref
    const timerOn = ref(false)
    const timerInterval = ref()
    // 描画用のref
    const leftMinutes = ref(30)
    const leftSeconds = ref(0)
    // 終了関数
    // 時間切れの場合
    const timerOver = () => {
      clearInterval(timerInterval.value)
      router.push(`/magazines/exam/cbt/${route.params.category}/fail`)
    }
    // 時間内に終了した場合
    const timerEnd = () => {
      clearInterval(timerInterval.value)
    }
    // カウント関数。1秒ごとに実行
    const countDown = () => {
      if (leftSeconds.value <= 0 && leftMinutes.value >= 1) {
        leftMinutes.value--
        leftSeconds.value = 59
      } else if (leftSeconds.value <= 0 && leftMinutes.value <= 0) {
        timerOver()
      } else {
        leftSeconds.value--
      }
      const nowTime = {
        minutes: leftMinutes.value,
        seconds: leftSeconds.value
      }
      localStorage.setItem('nowTime', JSON.stringify(nowTime))
    }
    // 開始関数
    const timerStart = () => {
      timerInterval.value = setInterval(() => {
        countDown()
      }, 1000)
      timerOn.value = true
    }
    // 1→01にフォーマット処理
    const formatNumber = (n: number) => {
      return ('00' + n).slice(-2)
    }
    // ls保存用の日時取得
    const getCurrentTime = (): any => {
      return dayjs().format('YYYY/MM/DD HH:mm:ss')
    }

    onMounted(() => {
      // lsとmyAnswersを同期
      if (localStorage.getItem('myAnswers')) {
        const lsAnswers = JSON.parse(localStorage.getItem('myAnswers') + '')
        lsAnswers.forEach((element: any) => {
          myAnswers.push(element)
        })
      }
    })

    // ボタン押下時の処理
    const linkToResultText = ref('解答を送信する')
    const hasError = ref(false)
    const linkToResult = () => {
      linkToResultText.value = '送信中・・・'
      timerEnd()

      const answerSet = {
        qno: props.currentIndex + 1,
        wpqno: store.state.cbtQuestions[props.currentIndex].wpqno,
        answer: selectedIndex.value + ''
      }
      myAnswers.push(answerSet)
      // ここでapiにpostして成績送信する
      const string = route.params.category + ''
      const params = {
        users_id: store.state.userInfo.zip,
        year: '2022',
        term: Number(string.substring(string.length - 1)),
        flg: 'e',
        result: myAnswers,
        start_time: localStorage.getItem('startDate'),
        end_time: dayjs().format('YYYY/MM/DD HH:mm:ss')
      }
      const ajax = axiosSetting('app', 'action')
      ajax.post('/api/v1/cbt_question', params).then((res: any) => {
        if (res.status === 200) {
          // 成功した場合
          router.push(`/magazines/exam/cbt/${route.params.category}/result`)
        } else {
          // 失敗した場合
          hasError.value = true
          // 失敗したパターンの出力を試さないとわからない…
          // 想定されうるエラーパターンを洗い出す
          // 1. 時間切れだった場合
          console.log(res.err_msg)
        }
      })
    }
    const nextPage = () => {
      const answerSet = {
        qno: props.currentIndex + 1,
        wpqno: store.state.cbtQuestions[props.currentIndex].wpqno,
        answer: selectedIndex.value + ''
      }

      // 回答済みかチェック
      const answerIndex = myAnswers.findIndex(
        (item: any) => item.qno === props.currentIndex + 1
      )

      if (answerIndex !== -1) {
        // 既に回答済みの場合はlsを参照して値をセット（※2回戻って次へを押したとき対策
        myAnswers[answerIndex] = answerSet
        const nextAnswer = myAnswers[props.currentIndex + 1]
        selectedIndex.value = nextAnswer ? nextAnswer.answer : null
      } else {
        myAnswers.push(answerSet)
        selectedIndex.value = null
      }
      localStorage.setItem('myAnswers', JSON.stringify(myAnswers))
      router.push(
        `/magazines/exam/cbt/${route.params.category}/detail/${Number(
          route.params.qno
        ) + 1}`
      )
    }
    const previousPage = () => {
      const ls = JSON.parse(localStorage.getItem('myAnswers') + '')
      const previousAnswer = ls[props.currentIndex - 1].answer
      selectedIndex.value = previousAnswer

      router.push(
        `/magazines/exam/cbt/${route.params.category}/detail/${Number(
          route.params.qno
        ) - 1}`
      )
    }

    return {
      myAnswers,
      timerStart,
      getCurrentTime,
      selectedIndex,
      selectIndex,
      leftMinutes,
      leftSeconds,
      formatNumber,
      linkToResultText,
      hasError,
      linkToResult,
      nextPage,
      previousPage
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.cbt {
  letter-spacing: 0.03em;
  line-height: 1.5;
  h1 {
    display: none;
  }
}

.head {
  margin-top: 40px;
  font-weight: 500;
  position: relative;
  .number {
    font-size: 1.8rem;
    line-height: 1.34;
    padding-left: 9px;
    border-left: 4px solid var.$color-main;
  }
  .time {
    position: absolute;
    top: 0;
    right: 0;
    background-color: var.$color-sub-bg-g;
    color: var.$color-main-text;
    font-weight: bold;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 114px;
    height: 24px;
  }
  .question {
    margin-top: 24px;
    font-size: 1.8rem;
    line-height: 1.7;
    white-space: pre-wrap;
    word-wrap: break-word;
    @include mixins.media() {
      font-size: 2rem;
      line-height: 1.55;
    }
  }
}

.img {
  margin-top: 32px;
  text-align: center;
  @include mixins.media() {
    margin-top: 40px;
  }
  img + img {
    margin-top: 16px;
  }
}

.choices {
  margin-top: 32px;
  @include mixins.media() {
    margin: 24px -20px 0;
    display: flex;
    flex-wrap: wrap;
  }
  li {
    margin-top: 16px;
    @include mixins.media() {
      flex-basis: 50%;
      max-width: 50%;
      padding: 0 20px;
    }
  }
}
::v-deep .choices label {
  height: 60px;
  box-shadow: 0 3px 6px rgba($color: #000000, $alpha: 0.08);
  &::after {
    top: 25px;
  }
}

.btnArea {
  margin-top: 32px;
  background-color: var.$color-other-bg;
  padding: 24px 0;
  button + button {
    margin-top: 16px;
  }
  @include mixins.media() {
    margin-top: 40px;
    padding: 0;
    background-color: transparent;
  }
}
</style>
